__turbopack_context__.v({
  "asideFooter": "AsideFooter-module-scss-module__5agEiG__asideFooter",
  "backToTop": "AsideFooter-module-scss-module__5agEiG__backToTop",
  "button": "AsideFooter-module-scss-module__5agEiG__button",
  "icon": "AsideFooter-module-scss-module__5agEiG__icon",
  "withBackToTop": "AsideFooter-module-scss-module__5agEiG__withBackToTop",
});
